module.exports = __webpack_public_path__ + "img/sweden-skin-connective-and-musculoskeletal-diseases-male.be4766c7.png";